<template>
    <validation-observer ref="category">
        <b-card :title="$t('Page(PagesNewCategory):Component(Text):label')">
            <b-tabs>
                <b-tab
                    v-for="language in languages"
                    :title="language.code.toUpperCase()"
                >
                    <b-form-group
                        :label="$t('Component(Label):name')"
                        :label-for="'name' + language.code"
                    >
                        <validation-provider
                            #default="{ errors }"
                            :name="language.title + ' ' + $t('Component(Label):name')"
                            :rules="language.code === 'en' ? 'required' : null"
                        >
                            <b-form-input
                                :state="errors.length > 0 ? false:null"
                                :id="'name' + language.code"
                                v-model="category.translations[language.code].title"
                                :placeholder="$t('Component(Placeholder):name')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-tab>
            </b-tabs>
            <div class="text-right">
                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="primary"
                    class="mr-1"
                    @click="save"
                >
                    {{ $t('Component(Button):save') }}
                </b-button>

                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="primary"
                    @click="close"
                >
                    {{ $t('Component(Button):close') }}
                </b-button>
            </div>
        </b-card>
    </validation-observer>
</template>

<script>
import {BButton, BTabs, BTab, BCard, BFormGroup, BFormInput} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {i18nApi, PagesApi} from "@core/api";
import {required} from '@validations'
import Ripple from 'vue-ripple-directive'

export default {
    directives: {Ripple},
    components: {
        BButton, BTabs, BTab, BCard, ValidationProvider, ValidationObserver, BFormGroup, BFormInput,
    },
    props: {
        id: {
            default: null
        }
    },
    data() {
        return {
            languages: [],
            category: {},
            required,
        };
    },
    methods: {
        save() {
            this.$refs.category.validate().then(isValid => {
                if (!isValid) {
                    return;
                }
                if (this.id) {
                    PagesApi.updateCategory(this.id, this.category).then(this.gotoTheGrid);
                } else {
                    PagesApi.createCategory(this.category).then(this.gotoTheGrid);
                }
            });
        },
        close() {
            this.gotoTheGrid();
        },
        gotoTheGrid() {
            this.$router.push({name: 'administration-pages-categories'});
        }
    },
    created() {
        if (this.id) {
            PagesApi
                .getCategory(this.id)
                .then(r => this.category = r.data);
        }
        i18nApi.getLanguages().then(r => {
            if (!this.category.translations) {
                this.category.translations = {};
            }
            r.data.forEach(language => {
                if (this.category.translations[language.code] === undefined) {
                    this.$set(this.category.translations, language.code, {title: ''});
                }
            });
            this.languages = r.data
        });
    }
}
</script>
